<wiz-vgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  <wiz-hgroup width="100%" height="100%">

  <wiz-vgroup width="250px" height="100%" class="section-container"><!-- zone champs libres & filtre -->
    <wiz-hgroup  width="100%">
      <wiz-label width="100%" [wizLabel]="'$.freedata.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
      <wiz-icon  style="cursor: pointer;" class="image-purple"  [wizTooltip]="'$.common.delete.$'"  (click)="onDeleteClick()">delete </wiz-icon>
    </wiz-hgroup>
   
    <wiz-list
      #freeList
      id="freeList"
      height="100%"
      width="100%"
      [wizItemRenderer]="renderer"
      [wizDataProvider]="dataSource"
      [wizLabelField]="'fullCode'"
      [dragEnabled]="true"
    ></wiz-list>
    <filter-component #mainFilter> </filter-component>
  </wiz-vgroup>

  <wiz-vgroup #vgDetailZone width="100%" height="100%"> <!-- zone détail : poser les champs -->  
    <wiz-hgroup width="100%" height="50%" [visible]="useGridFunctions"><!-- zone filtre -->
      
      <wiz-vgroup width="100%" height="100%" minHeight="100px" class="section-container" ><!-- champs filtres --> 
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-filters</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.filter.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstFilter
            id="lstFilter"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
      </wiz-vgroup>

    </wiz-hgroup>

    <wiz-vgroup width="100%" height="100%"><!-- zone lignes et datas -->
      <freedata-tile-gridster #tile wizDragDrop [wizDropEnabled]="true" width="100%" height="100%" 
                  [freedataValue]="fakeFreeDataValue" (widgetsChanged)="onWidgetsChanged($event)" 
                  [widgets]="widgets" [templatingMode]="true"></freedata-tile-gridster>
    </wiz-vgroup>
  </wiz-vgroup>
  </wiz-hgroup>


  <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
    <wiz-vgroup width="100%">
      <wiz-checkbox #cbShowDeleteCol [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
      <wiz-hgroup>
        <wiz-checkbox #cbShowSelectCol [visible]="useGridFunctions" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
        <wiz-checkbox #cbSelectUnique [visible]="useGridFunctions" [wizLabel]="'$.pivot.edit.select.unique.$'"></wiz-checkbox>
      </wiz-hgroup>
      <!-- <wiz-checkbox #cbShowSelectCol [visible]="useGridFunctions" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox> -->
    </wiz-vgroup>
    <wiz-button
      #btnSave
      width="150px"
      (click)="doValid()"
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      width="150px"
      (click)="doCancel()"
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>

  <!-- fin zone détail -->
</wiz-vgroup>
